<template>
  <div class="fx_content">

    <div class="fenxi_con">
      <h1 class="title">实时调峰电费(元)</h1>
      <v-chart class="chart" :option="options" :autoresize="true" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "ShishiChuneng",
  components: {},
  props: {},
  setup() {
    var getname = [
      "1:00",
      "2:00",
      "3:00",
      "4:00",
      "5:00",
      "6:00",
      "7:00",
      "8:00",
      "9:00",
      "10:00",
      "11:00",
      "12:00",
    ];
    var getvalue = [55, 46, 30, 23, 55, 46, 30, 23, 55, 46, 30, 23];
    const options = ref({
      grid: {
        top: "5%",
        right: "4%",
        left: "10%",
        bottom: "35%",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
      },
      xAxis: [
        {
          type: "category",
          color: "#59588D",
          data: getname,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: 10,
            color: "#b4b8bf",
            textStyle: {
              fontSize: 13,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(49,218,255,0.5)",
            },
          },
          axisTick: {
            show: false,
          },
        },
      ],
      yAxis: [
        {
          //name: "单位:元",
          nameTextStyle: {
            color: "#B6E7FF",
          },
          //min: 0,
          //max: 100,
          axisLabel: {
            formatter: "{value}",
            color: "#b4b8bf",
            textStyle: {
              fontSize: 13,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#46C4FF",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(49,218,255,0.5)",
              type: "dashed",
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          data: getvalue,
          barWidth: "12px",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#2489ff", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2489ff", // 100% 处的颜色
                  },
                ],
                false
              ),
              barBorderRadius: [0, 0, 0, 0],
            },
          },
        },
      ],
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fx_content {
  position: relative;
  /*相对位置*/
  height: calc(100% - 15px);
}

.fenxi {
  background: url("@/assets/conbg.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}

.fenxi_con {
  width: 100%;
  position: absolute;
  height: 100%;
}

.title {
  color: #fff;
  font-size: 15px;
  padding: 5px 30px 10px 40px;
  font-weight: bold;
  background: url("@/assets/biaoti.png") 10px 5px;
  background-repeat: no-repeat;
}
</style>
